import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {ApplicationInterface, KeyValueInterface, NameValueInterface} from "../interfaces";
import {Modal, ModalHeader, ModalBody} from "../../../components/Modal";
import CustomButton from "../../../components/CustomButton";
import iconAlert from "url:shared-assets/icons/red/alert.svg"
import iconInfo from "url:shared-assets/icons/white/information-circle.svg"
import RadioBox from "../../../components/Boxes/RadioBox";
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    leadershipLevels: Array<KeyValueInterface>
    save: Function
}

const roleLevels: Array<NameValueInterface> = [
    {
        name: "Extensive", value: 3
    },
    {
        name: "Moderate", value: 2
    },
    {
        name: "Basic", value: 1
    },
    {
        name: "None", value: 0
    }
]

const StepSeven: React.FC<Props> = (props: Props) => {
    const translation = useTranslation();
    const { t, i18n } = translation;
    const [roles, setRoles] = useState<Array<NameValueInterface>>(props.application.experienceByRole);
    const [showModal, setShowModal] = useState<boolean>(false)
    const [errors, setErrors] = useState<number>(0)
    const [triedSave, setTriedSave] = useState<boolean>(false)

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [roles])

    const checkInput = () => {
        let _errors = 0
        let _choices = 0
        for (const a of roles) {
            if (a.value > 0) _choices++
        }
        if (_choices < 1) {
            _errors++
        }
        setErrors(_errors)
        return _errors
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }
        const _application: ApplicationInterface = props.application
        _application.experienceByRole = roles
        props.save(_application)
    }

    const selectOption = (key: string, value: number) => {
        let found = false
        const _roles = [...roles]
        for (const a of _roles) {
            if (a.name === key) {
                a.value = value
                found = true
                break
            }
        }
        if (!found) {
            _roles.push({
                name: key,
                value: value
            })
        }
        setRoles(_roles)
    }

    const isSelected = (key: string, value: number) => {
        for (let role of roles) {
            if (role.name === key) {
                if (role.value === value) {
                    return true
                }
                return false
            }
        }
        return false
    }

    return (
      <>
        <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
            <ModalHeader onClose={() => setShowModal(false)}>
                Coaching experience by role
            </ModalHeader>
            <ModalBody>
                <p className="font-medium">
                    Non-managerial employees:
                </p>
                <p className="text-sm">
                    No leadership or supervisory responsibilities.
                </p>

                <p className="mt-4 font-medium">
                    Managers with team responsibility:
                </p>
                <p className="text-sm">
                    Managing collaboration and operational goals.
                </p>

                <p className="mt-4 font-medium">
                    Managers with personnel responsibility:
                </p>
                <p className="text-sm">
                    Overseeing hiring, performance, and careers.
                </p>

                <p className="mt-4 font-medium">
                    C-level executives:
                </p>
                <p className="text-sm">
                    Managing high-level decision-making.
                </p>

            </ModalBody>
        </Modal>

          <div className="mt-6 flex items-center">
              <div className="text-xl font-medium">Coaching experience by role</div>
              <img src={iconInfo} className="ml-2 cursor-pointer" alt="info" onClick={() => setShowModal(true)}/>
          </div>


          <div className="mt-4 text-neutral-400">
          Please indicate your level of experience in coaching employees in different roles.
          </div>

          {
              props.leadershipLevels.map((level: KeyValueInterface) => (
                <div className="mt-6" key={"level_" + level.key}>
                    <div className="text-lg font-medium">{level.value}</div>
                    {
                        roleLevels.map((role: NameValueInterface) => (
                          <div key={level.key + '_' + role.value} className="flex mt-2"
                               onClick={() => selectOption(level.key, role.value)}>
                              <RadioBox checked={isSelected(level.key, role.value)}/>
                              <div className="ml-2">
                                  {role.name}
                              </div>
                          </div>
                        ))
                    }
                </div>
              ))
          }

          {
            (triedSave && errors > 0) &&
              <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                  <img src={iconAlert} alt="error"/>
                  <div className="ml-2 font-medium">Please select experience level for at least one coaching area</div>
              </div>
          }

          <CustomButton className="mt-6" onClick={() => save()}>
              Next
          </CustomButton>
      </>
    )
}

export default StepSeven